import { render, staticRenderFns } from "./BroadcastDetail.vue?vue&type=template&id=7eef7422&scoped=true&"
import script from "./BroadcastDetail.vue?vue&type=script&lang=ts&"
export * from "./BroadcastDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BroadcastDetail.vue?vue&type=style&index=0&id=7eef7422&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eef7422",
  null
  
)

export default component.exports